<div class="content-wrap nommargin nopadding">
  <div class="col_full p-3">
    <app-language-modal></app-language-modal>
  </div>
</div>
